const isSet = <T>(value: T, defaultValue: T) => {
    return value === null || typeof value === 'undefined'
        ? defaultValue
        : value;
};

const ValidationFunctions = {
    isSet,
};

export { ValidationFunctions };
